import { useCallback } from 'react'

import { User } from '@modules/auth/hooks/types'
import { useAuthContext } from '@modules/auth/hooks/useAuthContext'
import { usePendoTrackEvent } from '@modules/pendo/hooks/usePendoTrackEvent'

import { AnalyticalEvent, BaseEvent } from './types'

export const useTrackUserActivity = () => {
  const { user } = useAuthContext()

  const { trackPendoEvent } = usePendoTrackEvent()

  const trackActivity = useCallback(
    (action: string, data?: Omit<AnalyticalEvent, 'eventType'>) => {
      const baseData = getBaseUserActivityData(user)

      trackPendoEvent(action, {
        eventType: action,
        ...baseData,
        ...data,
      })
    },
    [trackPendoEvent, user],
  )

  return { trackActivity }
}

function getBaseUserActivityData(user?: User | null): Omit<BaseEvent, 'eventType'> {
  return {
    visitor_id: user?.id,
    account_id: user?.companyId,
    timestamp: Date.now().toString(),
    user_agent: window.navigator.userAgent,
    location: window.location.pathname,
  }
}
